/* eslint-disable class-methods-use-this */
import store from '@/store/store';
import eventbus from 'tiny-emitter/instance';
import SVG from 'svg.js';
import { ZOOM, RENDERER_MODE, SECTIONSTATUS } from '@/constants';
import debounce from 'lodash/debounce';

export default class RendererMode {
  tapSvgTimeout = null;
  constructor(app) {
    this.app = app;
    this.isPinchIn = false;
    this.pinchDist = 0;
    this.lastP = null;
    this.wheeling = null;
    this.sections = [];
    this.currentZoom = this.app.zoomManager.zoom();

    this.debouncedOnZoomChange = debounce(this.onZoomChange.bind(this), 100);

    eventbus.on('seatmap:updated', this.onSeatmapUpdated, this);
    eventbus.on('camera:zoomed', this.onZoomChange, this);
    eventbus.on('camera:goInsideSection', this.goInsideSection, this);
    // app.svg.on('pinchZoomStart', this.handlePinchZoomStart, this);
    // app.svg.on('pinchZoomEnd', this.handlePinchZoomEnd, this);
    // app.svg.on('panStart', this.handlePanStart, this);
    // app.svg.on('panEnd', this.handlePanEnd, this);
    // app.svg.on('touchstart', this.handleCanvasDragStartMobile, this);
    // app.svg.on('touchend', this.handleCanvasDragFinishMobile, this);
    // app.svg.on('zoom', this.handleZoom, this);
    return this;
  }
  handleCanvasDragStartMobile(event) {
    // if (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }
    if (!event.touches) {
      return;
    }
    if (event.touches && event.touches.length === 1) {
      store.commit('seatmap/updatePanning', true);
      this.panCoord = null;
      const lthis = this;
      this.tapSvgTimeout = setTimeout(() => {
        SVG.off(window, 'touchmove', this.handleCanvasDragProcess, lthis);
        this.app.mobileTapping = true;
        this.app.mobilePanning = false;
        this.app.pinchZooming = false;
        const zone = this.app.seatmap.sections.find((s) => s.shape.node.id === event.target.id);
        if (zone && RENDERER_MODE && !zone.isInside) {
          eventbus.emit('tooltip:hide', zone);
          this.app.currentSection = zone;
          // //eventbus.emit('camera:zoom:fitElement', zone);
          // const { x, y } = zone.app.getTransformedCoords(event);
          // let level = ZOOM.LEVELS.INSIDESECTION;
          // if (lthis.app.isMobileDevice) {
          //   // for mobile
          //   level = ZOOM.MINFORMOBILE;
          // }
          // eventbus.emit('camera:zoom', level, ZOOM.MODES.SMOOTH, x, y);
          let point = this.app.svg.node.createSVGPoint();
          point.x = event.touches[0].clientX;
          point.y = event.touches[0].clientY;
          point = point.matrixTransform(this.app.svg.node.getScreenCTM().inverse());
          this.app.svg
            .animate(ZOOM.DURATIONS.SLOW)
            .zoom(this.app.seatmap.zoomForSection, { x: point.x, y: point.y })
            .afterAll(() => {
              this.handlePinchZoomEnd();
              eventbus.emit('camera:zoomed');
            });
        } else {
          const seat = this.app.seatmap.seatsAndTableSeats.find((s) => s.shape.node.id === event.target.id);
          if (seat) eventbus.emit('tooltip:show', seat);
        }
      }, 200);
    }
    SVG.on(window, 'touchmove', this.handleTouchmoveProcess, this);
  }
  handleTouchmoveProcess(event) {
    if (event.touches && event.touches.length === 1) {
      let movedDist = 0;
      if (this.panCoord !== undefined && this.panCoord !== null && this.panCoord.x !== undefined) {
        movedDist = Math.hypot(this.panCoord.x - event.touches[0].pageX, this.panCoord.y - event.touches[0].pageY);
      }
      this.panCoord = { x: event.touches[0].pageX, y: event.touches[0].pageY };
      if (this.app.mobileDelayedSelection && movedDist !== 0) {
        clearTimeout(this.app.mobileDelayedSelection);
      }
      if (this.tapSvgTimeout && movedDist !== 0) {
        clearTimeout(this.tapSvgTimeout);
      }
      this.app.mobilePanning = true;
      store.commit('seatmap/updatePanning', true);
    }
    //check to make sure there is data to compare against
    let clientX = event.clientX;
    let clientY = event.clientY;
    if (!clientX && event.touches) {
      clientX = event.touches[0].pageX;
      clientY = event.touches[0].pageY;
    }
    //#488 - Limit the Canvas Panning to where the seatmap is. User cannot pan indefinitely.
    if (RENDERER_MODE && !(clientX > 0 && clientY > 0 && clientX < window.innerWidth && clientY < window.innerHeight)) {
      this.canvasMoved = true;
      return;
    }
    //bypass pinch events
    if (event.touches && event.touches.length === 2) {
      return;
    }
    if (this.lastMovePosition) {
      //get the change from last position to this position
      const deltaX = (this.lastMovePosition.x - clientX) / this.currentZoom;
      const deltaY = (this.lastMovePosition.y - clientY) / this.currentZoom;
      eventbus.emit('camera:pan:xy', deltaX, deltaY);

      // store.commit('seatmap/updatePanning', true);
      this.canvasMoved = true;
    }
    //set the new last position to the current for next time
    this.lastMovePosition = {
      x: clientX,
      y: clientY,
    };
  }
  handleCanvasDragFinishMobile() {
    // if (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }
    this.app.pinchZooming = false;
    this.app.mobilePanning = false;
    this.app.mobileTapping = false;
    SVG.off(window, 'touchmove', this.handleTouchmoveProcess, this);
    SVG.off(document, 'blur', this.handleCanvasDragFinishMobile, this);
    SVG.off(window, 'blur', this.handleCanvasDragFinishMobile, this);
    if (this.canvasMoved) {
      store.commit('seatmap/updatePanning', false);
      setTimeout(() => {
        store.commit('seatmap/updateClickable', true);
      }, 300);
      eventbus.emit('canvas:moved');
      this.canvasMoved = false;
    }
    this.lastMovePosition = null;
  }
  handlePinchZoomStart() {
    this.app.pinchZooming = true;
    clearTimeout(this.tapSvgTimeout);
  }
  handlePinchZoomEnd() {
    this.app.pinchZooming = false;
    this.currentZoom = this.app.svg.zoom();
    eventbus.emit('menu:hide');
    if (this.currentZoom >= this.app.seatmap.zoomForSeat) {
      this.sections.forEach((s) => {
        if ((s.attributes.ga || s.category?.bestAvailable) && RENDERER_MODE) return;
        s.showSectionUnits();
        s.hideLabel();
        eventbus.emit('section:unfill', s);
        if (RENDERER_MODE) {
          s.view.removeClass('outside-view').addClass('inside-view');
        }
      });
    } else {
      this.sections.forEach((s) => {
        if ((s.attributes.ga || s.category?.bestAvailable) && RENDERER_MODE) return;
        s.hideSectionUnits();
        s.showLabel();
        eventbus.emit('section:fill', s);
        if (RENDERER_MODE) {
          s.view.removeClass('inside-view').addClass('outside-view');
        }
      });
    }
  }
  handlePanStart() {
    SVG.on(window, 'mousemove', this.handleMouseMove, this);
  }
  handleMouseMove(event) {
    if (event.touches && event.touches.length === 1) {
      const movementX = Math.abs(event.movementX);
      const movementY = Math.abs(event.movementY);
      // eslint-disable-next-line max-len
      if (movementX > 0 || movementY > 0) {
        store.commit('seatmap/updatePanning', true);
      }
    }
  }
  handlePanEnd(event) {
    setTimeout(() => {
      store.commit('seatmap/updatePanning', false);
      store.commit('seatmap/updateClickable', true);
    }, 300);
    eventbus.emit('canvas:moved');
    SVG.off(window, 'mousemove', this.handleMouseMove);
    event.preventDefault();
  }
  handleZoom() {
    if (this.app.isMobileDevice) return;
    clearTimeout(this.wheeling);
    this.wheeling = setTimeout(() => {
      this.wheeling = null;
      eventbus.emit('camera:zoomed');
    }, 250);
  }
  setupVisibilityChangeEvents() {
    SVG.on(document, 'blur', this.handleCanvasDragFinish, this);
    SVG.on(window, 'blur', this.handleCanvasDragFinish, this);
  }
  goInsideSection(section) {
    if (RENDERER_MODE) {
      const { cx, cy } = section.rbox();
      this.app.svg.zoom(this.app.seatmap.zoomForSection, { x: cx, y: cy });
    } else {
      const zoomLevel = this.app.zoomManager.zoom();
      if (zoomLevel > ZOOM.LEVELS.INSIDESECTION) {
        const { cx, cy } = section.rbox();
        eventbus.emit('camera:zoom', ZOOM.LEVELS.INSIDESECTION, ZOOM.MODES.SMOOTH, cx, cy);
      }
    }
  }
  onSeatmapUpdated(seats, units, sections) {
    sections.forEach((s) => s.hideSectionUnits());
    this.sections = sections;
    if (!RENDERER_MODE) {
      const level = sections.length ? ZOOM.LEVELS.SECTION : ZOOM.LEVELS.DEFAULTDESIGNER;
      eventbus.emit('camera:zoom', level);
    }
  }
  onZoomChange() {
    if (this.sections.length === 0) return;
    let show = false;
    if (RENDERER_MODE) {
      const currentZoom = this.app.zoomManager.zoom();
      //this.app.seatmap.scale
      show = currentZoom >= this.app.zoomManager.revealSeatLvl;
    } else {
      const zoomLevel = this.app.zoomManager.zoom();
      eventbus.emit('menu:hide');
      let sectionUnfillZoomLevel = ZOOM.LEVELS.INSIDESECTION;
      show = zoomLevel <= sectionUnfillZoomLevel;
    }

    if (show) {
      const revealSectionsMode = this.app.props.revealSectionsMode ? this.app.props.revealSectionsMode : 'self';
      let sectionsToReveal = this.sections.filter(
        (section) =>
          section.attributes.invisible !== true &&
          (!section.attributes.status || section.attributes.status === SECTIONSTATUS.AVAILABLE)
      );

      sectionsToReveal =
        revealSectionsMode == 'all'
          ? sectionsToReveal
          : this.app.props.revealSectionsMode == 'category' && this.app.currentSection
          ? sectionsToReveal.filter((section) => section.attributes.categoryId == this.app.currentSection.categoryId)
          : [this.app.currentSection];

      // if revealSectionMode is category or self, first hide all other sections
      // then show the required sections
      let allOtherSections = this.sections.filter((el) => !sectionsToReveal.includes(el));
      if (revealSectionsMode !== 'all') {
        allOtherSections.forEach((s) => {
          if (s && s.isInside) {
            if ((s.attributes.ga || s.category?.bestAvailable) && RENDERER_MODE) return;
            s.hideSectionUnits2();
            s.blocks.forEach((b) => {
              b.hide();
            });
            s.predefineds.forEach((u) => {
              u.hide();
            });
            s.showLabel();
            eventbus.emit('section:fill', s);
            if (RENDERER_MODE) {
              s.view.removeClass('inside-view').addClass('outside-view');
              s.removeBorder();
            }
          }
        });
      }

      sectionsToReveal.forEach((s) => {
        if (s && !s.isInside) {
          if ((s.attributes.ga || s.category?.bestAvailable) && RENDERER_MODE) return;
          s.showSectionUnits2();
          s.blocks.forEach((b) => {
            b.show();
          });
          s.predefineds.forEach((u) => {
            u.show();
          });
          s.hideLabel();
          eventbus.emit('section:unfill', s);
          if (RENDERER_MODE) {
            s.view.removeClass('outside-view').addClass('inside-view');
          }
        }
      });
    } else {
      this.sections.forEach((s) => {
        if (s && s.isInside) {
          if ((s.attributes.ga || s.category?.bestAvailable) && RENDERER_MODE) return;
          s.hideSectionUnits2();
          s.blocks.forEach((b) => {
            b.hide();
          });
          s.predefineds.forEach((u) => {
            u.hide();
          });
          s.showLabel();
          eventbus.emit('section:fill', s);
          if (RENDERER_MODE) {
            s.view.removeClass('inside-view').addClass('outside-view');
            s.removeBorder();
          }
        }
      });
    }
    this.app.seatmap.updateVisibility();
  }
  destroy() {
    eventbus.off('seatmap:updated', this.onSeatmapUpdated);
    eventbus.off('camera:zoomed', this.onZoomChange);
    eventbus.off('camera:goInsideSection', this.goInsideSection);
    // this.app.svg.off('pinchZoomStart', this.handlePinchZoomStart);
    // this.app.svg.off('pinchZoomEnd', this.handlePinchZoomEnd);
    // this.app.svg.off('panStart', this.handlePanStart);
    // this.app.svg.off('panEnd', this.handlePanEnd);
    // this.app.svg.off('touchstart', this.handleCanvasDragStartMobile);
    // this.app.svg.off('touchend', this.handleCanvasDragFinishMobile);
    // this.app.svg.off('zoom', this.handleZoom);
  }
}
